import get_header from "workflow/requests/get_header"

export default r => {
    // supports both fetch and xhttp

    const h = get_header(r, "content-length")

    try {
        return parseInt(h) || 0
    } catch (e) {
        return 0
    }
}
